import React, { useEffect, useState } from "react";
import { Dimensions, FlatList, StyleSheet, TouchableOpacity, View, Image, ScrollView, ActivityIndicator } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { checkWindowWidth, isCloseToBottom, isMobile, isMobileView } from "../../stack/utils";
import { getScreenType } from "../utils";
import { Icon } from "../../icon/Icon";
const isFromMobileView = isMobileView();
const numOfColumns = checkWindowWidth();
const flatListMobile = isMobile(getScreenType());
// @ts-ignore
const CollateralIntroCard = ({ customCollateralFullData, downloadAction, triggerAction, languageFilterAction, languagesSelected, counter, height, setCategoryAction, selectedCollateralCategory, selectedCollateralCategoryName }) => {
    const [categoriesList, setCategoriesList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(selectedCollateralCategory ? selectedCollateralCategory : 0);
    const [imageData, setImageData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(selectedCollateralCategoryName ? selectedCollateralCategoryName : '');
    const [isFilterSelected, setFilterSelected] = useState(false);
    const [temporaryImageData, setTemporaryImageData] = useState([]);
    const [temporaryIndex, setTemporaryIndex] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const scrollViewRef = React.useRef(null);
    const [tempListLength, setTempListLength] = useState(0);
    useEffect(() => {
        const uniqueData = [];
        let categoryArray = [];
        const allCategoryArray = [
            { collateral_category: "All" }
        ];
        categoryArray.push(...allCategoryArray);
        customCollateralFullData.forEach(item => {
            const isDuplicate = uniqueData.some(i => i.collateral_category === item.collateral_category);
            if (!isDuplicate) {
                uniqueData.push(item);
            }
        });
        uniqueData.unshift({
            public_url: "",
            collateral_category: "All",
            file_name: "",
            language: "",
        });
        setCategoriesList(uniqueData);
        setTemporaryImageData(imageData.slice(temporaryIndex, temporaryIndex + 2));
        setTempListLength(imageData.length);
    }, []);
    useEffect(() => {
        if (selectedItem === 0 && languagesSelected === undefined) {
            setShowLoader(true);
            setTemporaryImageData(prevData => [
                ...prevData,
                ...imageData.slice(temporaryIndex, temporaryIndex + 2)
            ]);
            setShowLoader(false);
            setTempListLength(imageData.length);
        }
    }, [temporaryIndex, imageData]);
    useEffect(() => {
        const category = selectedCategory ? selectedCategory : "All";
        let filteredData = [];
        temporaryIndex === 0 && setTemporaryImageData([]);
        if (isFromMobileView) {
            if (languagesSelected !== undefined) {
                if (languagesSelected.length !== 0) {
                    if (category === "All") {
                        filteredData = customCollateralFullData.filter((item) => {
                            if (languagesSelected.includes("All languages")) {
                                return item.collateral_category;
                            }
                            else {
                                return languagesSelected.includes(item['language '].trim());
                            }
                        });
                        setTemporaryImageData(prevData => [
                            ...prevData,
                            ...filteredData.slice(temporaryIndex, temporaryIndex + 2)
                        ]);
                        setTempListLength(filteredData.length);
                    }
                    else {
                        filteredData = customCollateralFullData.filter((item) => {
                            if (languagesSelected.includes("All languages")) {
                                return (item.collateral_category === category);
                            }
                            else {
                                return (languagesSelected.includes(item['language '].trim()) &&
                                    item.collateral_category === category);
                            }
                        });
                        setTemporaryImageData(prevData => [
                            ...prevData,
                            ...filteredData.slice(temporaryIndex, temporaryIndex + 2)
                        ]);
                        setTempListLength(filteredData.length);
                    }
                }
            }
            else {
                if (category === "All") {
                    filteredData = customCollateralFullData.filter((item) => {
                        return item.collateral_category;
                    });
                }
                else {
                    filteredData = customCollateralFullData.filter((item) => {
                        return (item.collateral_category === category);
                    });
                }
                setTemporaryImageData(prevData => [
                    ...prevData,
                    ...filteredData.slice(temporaryIndex, temporaryIndex + 2)
                ]);
                setTempListLength(filteredData.length);
            }
        }
        else {
            if (languagesSelected !== undefined) {
                if (languagesSelected.length !== 0) {
                    if (category === "All") {
                        filteredData = customCollateralFullData.filter((item) => {
                            if (languagesSelected.includes("All languages")) {
                                return item.collateral_category;
                            }
                            else {
                                return languagesSelected.includes(item['language '].trim());
                            }
                        });
                        setImageData(filteredData);
                    }
                    else {
                        filteredData = customCollateralFullData.filter((item) => {
                            if (languagesSelected.includes("All languages")) {
                                return (item.collateral_category === category);
                            }
                            else {
                                return (languagesSelected.includes(item['language '].trim()) &&
                                    item.collateral_category === category);
                            }
                        });
                        setImageData(filteredData);
                    }
                }
            }
            else {
                if (category === "All") {
                    filteredData = customCollateralFullData.filter((item) => {
                        return item.collateral_category;
                    });
                }
                else {
                    filteredData = customCollateralFullData.filter((item) => {
                        return (item.collateral_category === category);
                    });
                }
                setImageData(filteredData);
            }
        }
    }, [languagesSelected, selectedCategory, temporaryIndex]);
    useEffect(() => {
        if (languagesSelected !== undefined) {
            if (languagesSelected.length === 0) {
                setFilterSelected(false);
            }
            else if (languagesSelected.includes("All languages")) {
                setFilterSelected(false);
            }
            else {
                setTemporaryIndex(0);
                scrollToTop();
                setFilterSelected(true);
            }
        }
    }, [languagesSelected]);
    const scrollToTop = () => {
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ y: 0, animated: false });
        }
    };
    const handleItemPress = (item, index) => {
        setTemporaryIndex(0);
        setSelectedItem(index);
        triggerAction({
            ...setCategoryAction,
            payload: {
                selectedCategory: index,
                selectedCollateralCategoryName: item.collateral_category
            }
        });
        setSelectedCategory(item.collateral_category);
        scrollToTop();
        const category = item.collateral_category ? item.collateral_category : "All";
        let languageFilteredData = [];
        if (languagesSelected !== undefined) {
            if (category === "All") {
                languageFilteredData = customCollateralFullData.filter((item) => {
                    if (languagesSelected.includes("All languages")) {
                        return item.collateral_category;
                    }
                    else {
                        return languagesSelected.includes(item['language '].trim());
                    }
                });
            }
            else {
                languageFilteredData = customCollateralFullData.filter((item) => {
                    if (languagesSelected.includes("All languages")) {
                        return (item.collateral_category === category);
                    }
                    else {
                        return (languagesSelected.includes(item['language '].trim()) &&
                            item.collateral_category === category);
                    }
                });
            }
            if (isFromMobileView) {
                setTemporaryImageData(prevData => [
                    ...prevData,
                    ...languageFilteredData.slice(temporaryIndex, temporaryIndex + 2)
                ]);
            }
            else {
                setImageData(languageFilteredData);
            }
            setTempListLength(languageFilteredData.length);
        }
        else {
            const filteredData = customCollateralFullData.filter(itemF => itemF.collateral_category === item.collateral_category);
            if (item.collateral_category === "All") {
                if (isFromMobileView) {
                    setTemporaryImageData(prevData => [
                        ...prevData,
                        ...customCollateralFullData.slice(temporaryIndex, temporaryIndex + 2)
                    ]);
                }
                else {
                    setImageData(customCollateralFullData);
                }
                setTempListLength(customCollateralFullData.length);
            }
            else {
                if (isFromMobileView) {
                    setTemporaryImageData(prevData => [
                        ...prevData,
                        ...filteredData.slice(temporaryIndex, temporaryIndex + 2)
                    ]);
                    setTempListLength(filteredData.length);
                }
                else {
                    setImageData(filteredData);
                }
            }
        }
    };
    const bannerTypeItem = (item, index) => {
        const isSelected = index === selectedItem;
        return (React.createElement(TouchableOpacity, { onPress: () => handleItemPress(item, index) },
            React.createElement(View, { style: isSelected ? styles.selectedBannerTypeItem : styles.bannerTypeItem },
                React.createElement(Typography, { label: item.collateral_category, fontSize: FontSizeTokens.SM, fontWeight: "500", fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: isSelected ? ColorTokens.White : ColorTokens.Grey_Charcoal }))));
    };
    const bannerTypeItemSeparator = () => {
        return (React.createElement(View, { style: styles.bannerTypeItemSeparator }));
    };
    const collateralImageItemSeparator = () => {
        return (React.createElement(View, { style: styles.collateralImageItemSeparator }));
    };
    const emptyDataView = () => {
        return (React.createElement(View, { style: {
                alignSelf: 'flex-start',
                marginLeft: flatListMobile ? 30 : 350,
                alignContent: 'center',
                alignItems: 'center',
                marginTop: 12
            } },
            React.createElement(Typography, { label: "No template for this category", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Charcoal, fontWeight: "600", lineHeight: 40 })));
    };
    const collateralBannerImageList = () => {
        return isFromMobileView ? (React.createElement(ScrollView, { onScroll: ({ nativeEvent }) => {
                if (isCloseToBottom(nativeEvent)) {
                    if (temporaryIndex < tempListLength) {
                        setTemporaryIndex(temporaryIndex + 2);
                    }
                }
            }, style: {
                height: showLoader ? height - 400 : height - 350,
                paddingBottom: 80,
                marginTop: 16,
            }, ref: scrollViewRef },
            React.createElement(FlatList, { data: temporaryImageData, renderItem: ({ item, index }) => collateralBanner(item, index), keyExtractor: (item, index) => "" + index, numColumns: numOfColumns, showsHorizontalScrollIndicator: false, showsVerticalScrollIndicator: isFromMobileView, ItemSeparatorComponent: collateralImageItemSeparator, ListEmptyComponent: () => {
                    return (React.createElement(View, { style: { marginRight: isFromMobileView ? 12 : 60 } }, emptyDataView()));
                }, ListFooterComponent: () => (temporaryImageData.length !== 0 && temporaryIndex < tempListLength) &&
                    React.createElement(ActivityIndicator, { color: '#1434CB', size: 22 }) }))) : (React.createElement(ScrollView, null,
            React.createElement(FlatList, { data: imageData, renderItem: ({ item, index }) => collateralBanner(item, index), keyExtractor: (item, index) => "" + index, numColumns: numOfColumns, showsHorizontalScrollIndicator: false, style: numOfColumns === 1 && {
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignSelf: 'center',
                    alignItems: 'center'
                }, ItemSeparatorComponent: collateralImageItemSeparator, ListEmptyComponent: () => {
                    return (React.createElement(View, { style: { marginRight: 60 } }, emptyDataView()));
                } })));
    };
    const bannerTypeList = () => {
        return (React.createElement(FlatList, { data: categoriesList, renderItem: ({ item, index }) => bannerTypeItem(item, index), horizontal: true, keyExtractor: (item, index) => "" + index, showsHorizontalScrollIndicator: false, style: {
                width: numOfColumns !== 2 ? Dimensions.get('window').width : Dimensions.get('window').width - 100,
                paddingRight: 40
            }, ItemSeparatorComponent: bannerTypeItemSeparator }));
    };
    const showMostCollateralBanner = () => {
        let showBanner = false;
        const category = selectedCategory ? selectedCategory : "All";
        if ((languagesSelected === undefined || languagesSelected.length === 0) && category === "All") {
            showBanner = true;
        }
        else if ((languagesSelected !== undefined && languagesSelected.includes("All languages")) && category === "All") {
            showBanner = true;
        }
        else {
            showBanner = false;
        }
        return showBanner;
    };
    const collateralBanner = (item, index) => {
        const imageUrl = item.public_url !== undefined ? item.public_url : item?.item.public_url !== undefined ? item.item.public_url : item.item;
        return (React.createElement(View, { style: styles.collateralBanner },
            React.createElement(View, { style: styles.collateralImage },
                React.createElement(Image, { style: { width: 302, height: 304 }, source: { uri: imageUrl } }),
                index < 2 && showMostCollateralBanner() &&
                    React.createElement(View, { style: styles.overlayContainer },
                        React.createElement(View, { style: styles.overlay },
                            React.createElement(Typography, { label: "Most downloaded", fontWeight: "600", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXS, lineHeight: 16, color: ColorTokens.Mustard_Yellow })))),
            React.createElement(View, { style: styles.collateralBannerBottom },
                React.createElement(Button, { onPress: async () => {
                        await triggerAction({
                            ...downloadAction,
                            payload: {
                                imageUrl: imageUrl,
                                file_name: item.file_name,
                                collateralCategory: item.collateral_category,
                                ...downloadAction.payload
                            }
                        });
                    }, type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Create co-branded collateral", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS }),
                React.createElement(Space, { size: SizeTypeTokens.LG }))));
    };
    const filterView = () => {
        return (React.createElement(View, { style: {
                height: (isFilterSelected && !flatListMobile) ? 44 : 24,
                width: flatListMobile ? '100%' : 108,
                marginRight: isFilterSelected ? flatListMobile ? -12 : 32 : -18,
                marginBottom: (isFilterSelected && !flatListMobile) ? 16 : flatListMobile ? 4 : 0,
                position: 'relative',
                alignSelf: 'flex-end',
                marginLeft: flatListMobile && 16,
                marginTop: flatListMobile ? 4 : isFilterSelected ? -16 : 0,
            } },
            React.createElement(TouchableOpacity, { style: [styles.filterView, {
                        backgroundColor: isFilterSelected ? "#F3F5FC" : 'white',
                        marginTop: isFilterSelected && 14
                    }], onPress: () => {
                    triggerAction({
                        ...languageFilterAction,
                        payload: {
                            value: customCollateralFullData,
                            filtersSelected: languagesSelected,
                        }
                    });
                } },
                React.createElement(Typography, { label: "Filter", fontWeight: "500", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Primary_100 }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Icon, { name: IconTokens.Filter, size: IconSizeTokens.XL })),
            isFilterSelected &&
                React.createElement(View, { style: styles.filterNumberOverlay },
                    React.createElement(Typography, { label: `${languagesSelected.length}`, fontSize: FontSizeTokens.XXS, lineHeight: 18, color: ColorTokens.White, fontWeight: "400" }))));
    };
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: flatListMobile ? styles.columnContainer : styles.rowContainer },
            bannerTypeList(),
            React.createElement(View, { style: flatListMobile && {
                    marginTop: !isFilterSelected && 8,
                    marginLeft: 4,
                    width: Dimensions.get('window').width - 60,
                    marginBottom: isFilterSelected && 16,
                } }, filterView())),
        React.createElement(View, { style: isFromMobileView && { alignSelf: 'center', width: '100%' } }, collateralBannerImageList())));
};
const styles = StyleSheet.create({
    container: {
        marginTop: 24,
        width: Dimensions.get('window').width > 1800 ? '90%' : '100%',
    },
    rowContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '90%',
    },
    columnContainer: {
        width: '100%',
        flexDirection: 'column',
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlayContainer: {
        ...StyleSheet.absoluteFillObject,
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        marginRight: 16,
        marginTop: 16,
        width: 120,
        top: 0,
        right: 0,
        marginLeft: 172,
    },
    overlay: {
        justifyContent: 'center',
        alignItems: 'center',
        height: 28,
        borderRadius: 24,
        borderWidth: 1,
        borderColor: '#FCC026',
        paddingVertical: 6,
        paddingHorizontal: 16,
        backgroundColor: '#FDF7E7',
    },
    bannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: "#F3F5FC",
        justifyContent: 'center',
        alignContent: 'center'
    },
    bannerTypeItemSeparator: {
        marginLeft: 12
    },
    collateralBanner: {
        height: 372,
        width: 304,
        marginTop: 24,
        marginRight: 24,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8,
        paddingBottom: 12,
        boxShadow: '0px 2px 5px rgba(9, 30, 66, 0.2)',
        marginBottom: 24,
        flexDirection: 'column',
        alignContent: 'center',
        alignSelf: 'center',
        marginLeft: flatListMobile && 36
    },
    collateralBannerBottom: {
        height: 56,
        width: 304,
        position: 'absolute',
        bottom: 0,
        padding: 12,
        justifyContent: 'center',
        alignContent: 'center',
        backgroundColor: 'transparent',
    },
    collateralImage: {},
    collateralImageItemSeparator: {
        width: 24
    },
    downloadCTA: {
        paddingBottom: 12
    },
    selectedBannerTypeItem: {
        height: 32,
        borderRadius: 32,
        paddingVertical: 6,
        paddingHorizontal: 24,
        backgroundColor: '#1434CB',
        justifyContent: 'center',
        alignContent: 'center'
    },
    collateralBannerList: {
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        marginRight: 4
    },
    filterView: {
        width: 108,
        height: 32,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: flatListMobile ? 'flex-end' : 'center',
        justifyContent: 'flex-end',
        ...flatListMobile && {
            marginTop: 16
        },
        paddingVertical: 6,
        paddingHorizontal: 23,
        borderRadius: 23,
        borderWidth: 1,
        borderColor: '#1434CB',
        position: 'absolute',
    },
    filterNumberOverlay: {
        alignItems: 'center',
        alignSelf: 'flex-end',
        justifyContent: 'center',
        width: 20,
        height: 20,
        marginBottom: 12,
        backgroundColor: "#1434CB",
        borderRadius: 32,
        top: 0,
        right: 0,
        marginRight: 8
    }
});
// @ts-ignore
export default (CollateralIntroCard);
